exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".answers__result[data-v-4e2f0949]{font-family:Open Sans,sans-serif;font-weight:400;line-height:1.35}.answers__result[data-v-4e2f0949],.answers__result span[data-v-4e2f0949],.answers__row[data-v-4e2f0949]{transition:all .3s ease-in-out}.answers__row[data-v-4e2f0949]{padding:18px 12px}.answers__row[data-v-4e2f0949]:nth-child(odd){background-color:#f4f4f4}.answers__row[data-v-4e2f0949]:hover{background-color:#322e47}.answers__row:hover .answers__result[data-v-4e2f0949],.answers__row:hover .answers__result span[data-v-4e2f0949]{color:#fff}.answers__result[data-v-4e2f0949]{font-size:14px;color:#5e5e5e}.answers__result span[data-v-4e2f0949]{white-space:nowrap;color:#363636;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e2f0949","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/anketaresult/Result.vue
// module id = 04ee12cc4f16131ac5c7
// module chunks = 5